import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { DatePicker } from 'antd';

import { useTranslation } from 'react-i18next';
import AddInventoryModal from '../components/AddInventoryModal';
import { usePermissions } from '../../../contexts/PermissionsContext';
import Pagination from '../../../components/Pagination';
import dayjs from 'dayjs';
import {
  exportInventory,
  fetchInventory,
  fetchOrigins,
  fetchProductCategories,
  importInventory,
} from '../services/inventoryService';
import Loader from '../../../components/Loader';
import ImportInventoryModal from '../components/ImportInventoryModal';
import { trimDecimalZero } from '../../../utils/commonUtils';
import FileNames from '../../../constants/fileNames';

export default function Inventory() {
  const dateFormat = 'YYYY/MM/DD';
  const today = new Date().toISOString().split('T')[0]; // gives "YYYY-MM-DD"
  const { t } = useTranslation('Inventory');
  const { permissions } = usePermissions();

  const [addModal, setAddModal] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [inventoryData, setInventoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [productCategories, setProductCategories] = useState([]);
  const [origins, setOrigins] = useState([]);
  const [dateFilter, setDateFilter] = useState(today);
  const [pagination, setPagination] = useState({
    total: 0,
    current_page: 1,
    last_page: 1,
    per_page: 20,
  });
  const [filters, setFilters] = useState({
    productCategories: [],
    origins: [],
  });
  const handleModalSuccess = () => {
    fetchData(1);
  };
  const fetchData = async (page = 1, ifSearch = 0) => {
    setLoading(true);
    try {
      const per_page = 50;

      const query = {
        page,
        per_page,
        productCategories: filters.productCategories,
        origins: filters.origins,
        search: searchQuery,
        date: dateFilter || today,
      };
      if (ifSearch) {
        const inventoryResponse = await fetchInventory(query);
        if (inventoryResponse.inventory) {
          setInventoryData(inventoryResponse.inventory);
        }
        if (inventoryResponse.pagination) {
          setPagination({
            total: inventoryResponse.pagination.total,
            current_page: inventoryResponse.pagination.current_page,
            last_page: inventoryResponse.pagination.last_page,
            per_page: inventoryResponse.pagination.per_page,
          });
        }
      } else {
        const [inventoryResponse, productCategoriesResponse, originResponse] =
          await Promise.all([
            fetchInventory(query),

            fetchProductCategories(),

            fetchOrigins(),
          ]);
        if (inventoryResponse.inventory) {
          setInventoryData(inventoryResponse.inventory);
        }

        if (productCategoriesResponse.success) {
          setProductCategories(productCategoriesResponse.product_categories);
        }

        if (originResponse.success) {
          setOrigins(originResponse.origins);
        }

        if (inventoryResponse.pagination) {
          setPagination({
            total: inventoryResponse.pagination.total,
            current_page: inventoryResponse.pagination.current_page,
            last_page: inventoryResponse.pagination.last_page,
            per_page: inventoryResponse.pagination.per_page,
          });
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData(pagination.current_page);
  }, [pagination.current_page]);
  useEffect(() => {
    console.log('search query', searchQuery);
    const delayDebounceFn = setTimeout(() => {
      console.log(searchQuery);
      fetchData(1, 1);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery, filters, dateFilter]);
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= pagination.last_page) {
      setPagination((prev) => ({
        ...prev,
        current_page: pageNumber,
      }));
    }
  };
  const handleFilterChange = (filterType, value) => {
    console.log('on filter change.....', filterType, value);
    setFilters((prev) => {
      const newFilterState = { ...prev };

      // Handle "ALL" selection separately
      if (value === 'ALL') {
        // Toggle all items for the current filter type (categories, origins, or process locations)
        newFilterState[filterType] =
          newFilterState[filterType].length ===
          filterTypeData[filterType].length
            ? [] // Deselect all
            : filterTypeData[filterType].map((item) => item.id); // Select all
      } else {
        // Handle individual item selection/deselection
        newFilterState[filterType] = newFilterState[filterType].includes(value)
          ? newFilterState[filterType].filter((item) => item !== value) // Deselect the item
          : [...newFilterState[filterType], value]; // Select the item
      }

      return newFilterState;
    });
  };

  // Define the filter data for each type dynamically
  const filterTypeData = {
    productCategories: productCategories,
    origins: origins,
  };

  const handleImportInventory = async (formData) => {
    setImportLoading(true);
    const response = await importInventory(formData);
    setImportLoading(false);
    fetchData(1, 0);
    return response;
    // handleCloseModal("import");
  };
  const handleDateFilterChange = (date, dateString) => {
    console.log('date: ', dateString);
    setDateFilter(dateString);
  };
  const disableFutureDates = (current) => {
    return current && current > dayjs().endOf('day');
  };
  const handleExportOrders = async () => {
    const data = {
      productCategories: filters.productCategories,
      origins: filters.origins,
      search: searchQuery,
      date: dateFilter || today,
    };

    const response = await exportInventory(
      data,
      FileNames.FBZ_INVENTORY_EXPORT
    );
  };

  return (
    <main className="fbz-customer product-page inventory-page">
      <section className="main-section">
        <section className="data on-responsive-block">
          <div className="row">
            <div className="col-sm-12 col-xl-3 col-md-4">
              <div className="left">
                <h1>{t('FBZINVENTORY')}</h1>
                <div className="input-div">
                  <div className="input-card">
                    <img src="images/search-icon.svg" alt="" />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder={t('SEARCH')}
                    />
                  </div>
                  <div className="filter-section date">
                    <label>{t('DATE')}</label>
                    <div className="date-picker range-picker">
                      <DatePicker
                        onChange={handleDateFilterChange}
                        defaultValue={dayjs(dateFilter, dateFormat)}
                        placeholder={t('SELECTDATE')}
                        format={dateFormat}
                        disabledDate={disableFutureDates}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-xl-4 col-sm-12">
              <div className="right">
                <div className="filter-container">
                  <div className="filter-section">
                    <label>{t('ORIGIN')}</label>
                    <div className="checkbox-group pro-filter">
                      <label className="custom-checkbox ">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={filters.origins.length === origins.length}
                          onChange={() => handleFilterChange('origins', 'ALL')}
                        />
                        <span className="checkmark"></span>
                      </label>
                      {origins.map((origin) => (
                        <label key={origin.id} className="custom-checkbox">
                          {origin.name}
                          <input
                            type="checkbox"
                            checked={filters.origins.includes(origin.id)}
                            onChange={() =>
                              handleFilterChange('origins', origin.id)
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="filter-section">
                    <label>{t('PRODUCTCATEGORY')}</label>
                    <div className="checkbox-group pro-filter">
                      <label className="custom-checkbox">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={
                            filters.productCategories.length ===
                            productCategories.length
                          }
                          onChange={() =>
                            handleFilterChange('productCategories', 'ALL')
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      {productCategories.map((productCategory) => (
                        <label
                          key={productCategory.id}
                          className="custom-checkbox"
                        >
                          {productCategory.name}
                          <input
                            type="checkbox"
                            checked={filters.productCategories.includes(
                              productCategory.id
                            )}
                            onChange={() =>
                              handleFilterChange(
                                'productCategories',
                                productCategory.id
                              )
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-xl-5 col-sm-12">
              <div className="right right-change-cs">
                <div className="filter-container">
                  {permissions?.['FBZ_INVENTORY']?.edit_permission === 1 && (
                    <div className="button-group">
                      <button
                        className="add-btn"
                        onClick={() => {
                          setAddModal(true);
                        }}
                      >
                        + {t('ADD')}
                      </button>
                      <button
                        className="'import-btn"
                        onClick={() => {
                          setImportModal(true);
                        }}
                      >
                        <img src="images/import.svg" alt="" />
                        {t('IMPORT')}
                      </button>
                      <button onClick={handleExportOrders}>
                        <img src="images/export.svg" alt="" />
                        {t('EXPORT')}
                      </button>
                      {/* <button
                        className="add-btn"
                        onClick={() => {
                          setAddModal(true);
                        }}
                      >
                        + {t('ADD')}
                      </button> */}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="col-sm-6">
              <div className="left">
                <h1>{t('FBZINVENTORY')}</h1>
                <div className="input-card">
                  <img src="images/search-icon.svg" alt="" />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder={t('SEARCH')}
                  />
                </div>
                <div className="filter-section date">
                  <label>{t('DATE')}</label>
                  <div className="date-picker range-picker">
                    <DatePicker
                      onChange={handleDateFilterChange}
                      defaultValue={dayjs(dateFilter, dateFormat)}
                      placeholder={t('SELECTDATE')}
                      format={dateFormat}
                      disabledDate={disableFutureDates}
                    />
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-sm-6">
              <div className="right">
                <div className="filter-container"> */}
            {/* <div className="filter-section date">
                    <label>{t('DATE')}</label>
                    <div className="date-picker range-picker">
                      <DatePicker
                        onChange={handleDateFilterChange}
                        defaultValue={dayjs(dateFilter, dateFormat)}
                        placeholder={t('SELECTDATE')}
                        format={dateFormat}
                        disabledDate={disableFutureDates}
                      />
                    </div>
                  </div> */}
            {/* <div className="filter-section">
                    <label>{t('ORIGIN')}</label>
                    <div className="checkbox-group pro-filter">
                      <label className="custom-checkbox ">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={filters.origins.length === origins.length}
                          onChange={() => handleFilterChange('origins', 'ALL')}
                        />
                        <span className="checkmark"></span>
                      </label>
                      {origins.map((origin) => (
                        <label key={origin.id} className="custom-checkbox">
                          {origin.name}
                          <input
                            type="checkbox"
                            checked={filters.origins.includes(origin.id)}
                            onChange={() =>
                              handleFilterChange('origins', origin.id)
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="filter-section">
                    <label>{t('PRODUCTCATEGORY')}</label>
                    <div className="checkbox-group pro-filter">
                      <label className="custom-checkbox">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={
                            filters.productCategories.length ===
                            productCategories.length
                          }
                          onChange={() =>
                            handleFilterChange('productCategories', 'ALL')
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      {productCategories.map((productCategory) => (
                        <label
                          key={productCategory.id}
                          className="custom-checkbox"
                        >
                          {productCategory.name}
                          <input
                            type="checkbox"
                            checked={filters.productCategories.includes(
                              productCategory.id
                            )}
                            onChange={() =>
                              handleFilterChange(
                                'productCategories',
                                productCategory.id
                              )
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div> */}

            {/* {permissions?.['FBZ_INVENTORY']?.edit_permission === 1 && (
                    <div className="button-group">
                      <button
                        className="add-btn"
                        onClick={() => {
                          setAddModal(true);
                        }}
                      >
                        + {t('ADD')}
                      </button>
                      <button
                        className="'import-btn"
                        onClick={() => {
                          setImportModal(true);
                        }}
                      >
                        <img src="images/import.svg" alt="" />
                        {t('IMPORT')}
                      </button>
                      <button onClick={handleExportOrders}>
                        <img src="images/export.svg" alt="" />
                        {t('EXPORT')}
                      </button> */}
            {/* <button
                        className="add-btn"
                        onClick={() => {
                          setAddModal(true);
                        }}
                      >
                        + {t('ADD')}
                      </button> */}
            {/* </div>
                  )} */}
            {/* </div>
              </div>
            </div> */}
          </div>
        </section>
        {/* <!-- Table start --> */}

        <div className="table-outer">
          <table className="table">
            <thead>
              <tr className="t-heading">
                <th className="category">
                  <h5>{t('PRODUCTCODE')}</h5>
                </th>
                <th className="stock-name">
                  <h5>{t('PRODUCTNAME')}</h5>
                </th>
                <th className="stock-name">
                  <h5>{t('SPECIFICATION')}</h5>
                </th>
                <th className="stock-name">
                  <h5>{t('CATEGORY')}</h5>
                </th>
                <th className="stock-name">
                  <h5>{t('ORIGIN')}</h5>
                </th>
                <th className="origin">
                  <h5>{t('OPENINGBALANCE')}</h5>
                </th>
                <th className="origin">
                  <h5>{t('STOCKIN')}</h5>
                </th>
                <th className="origin">
                  <h5>{t('PRODUCTCONVERT(IN)')}</h5>
                </th>
                <th className="origin">
                  <h5>{t('PRODUCTCONVERT(OUT)')}</h5>
                </th>
                <th className="origin">
                  <h5>{t('STOCKOUT')}</h5>
                </th>
                <th className="stock-balnce">
                  <h5>{t('CLOSINGBALANCE')}</h5>
                </th>
              </tr>
            </thead>
            {loading ? (
              <tr>
                <td colSpan="100%" className="p-0">
                  <Loader />
                </td>
              </tr>
            ) : (
              <>
                <tbody>
                  {inventoryData.length === 0 ? (
                    <tr>
                      <td colSpan="100%" className="text-center py-4">
                        {t('NORECORDAVAILABLE')}
                      </td>
                    </tr>
                  ) : (
                    inventoryData.map((inventory, index) => (
                      <tr>
                        <td className="code">
                          <h5>{inventory.product_code}</h5>
                        </td>
                        <td className="stock-name">
                          <h5>{inventory.product_name}</h5>
                        </td>
                        <td className="stock-name specification">
                          <h5>{inventory.product_specification || ''}</h5>
                        </td>
                        {/* <td className="stock-name category">
                          <h5>{inventory?.product_process_category || ''}</h5>
                        </td> */}
                        <td className="stock-name category">
                          <h5>{inventory?.product_category || ''}</h5>
                        </td>
                        <td className="stock-name origin">
                          <h5>{inventory?.product_origin || ''}</h5>
                        </td>
                        <td className="origin">
                          <h5>
                            {trimDecimalZero(inventory.opening_balance) ?? ''}
                          </h5>
                        </td>
                        <td className="origin">
                          <h5>
                            {Number(inventory.stock_in) === 0
                              ? ''
                              : inventory.stock_in}
                          </h5>
                        </td>
                        <td className="origin">
                          <h5>
                            {Number(inventory.convert_in) === 0
                              ? ''
                              : inventory.convert_in}
                          </h5>
                        </td>
                        <td className="origin">
                          <h5>
                            {Number(inventory.convert_out) === 0
                              ? ''
                              : inventory.convert_out}
                          </h5>
                        </td>
                        <td className="origin">
                          <h5>
                            {Number(inventory.stock_out) === 0
                              ? ''
                              : inventory.stock_out}
                          </h5>
                        </td>

                        <td className="stock-balnce">
                          <h5>
                            {trimDecimalZero(inventory.closing_balance) ?? ''}
                          </h5>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </>
            )}
          </table>
        </div>
        <Pagination
          currentPage={pagination.current_page}
          totalPages={pagination.last_page}
          paginate={paginate}
          loading={loading}
        />
        <Modal
          isOpen={addModal}
          onRequestClose={() => setAddModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add `}
          portalClassName="add"
        >
          <AddInventoryModal
            setAddModal={setAddModal}
            onSuccess={handleModalSuccess}
          />
        </Modal>
        <Modal
          isOpen={importModal}
          onRequestClose={() => setImportModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add `}
          portalClassName="add"
        >
          <ImportInventoryModal
            setImportModal={setImportModal}
            onSuccess={handleModalSuccess}
            importLoading={importLoading}
            handleImportInventory={handleImportInventory}
          />
        </Modal>
      </section>
    </main>
  );
}
